import { FC } from "preact/compat";
import { cva } from "class-variance-authority";
import Dialog from "./Dialog";
import { ClassicDialogProps } from "./interfaces";
import Loader from "~/assets/loader.svg";
import cn from "classnames";

export const classicDialogVariants = cva(
    "max-w-[calc(100vw-40px)] rounded-3xl shadow-lg",
    {
        variants: {
            variant: {
                classic: "rounded-3xl shadow-lg",
            },
            size: {
                sm: "w-[20rem]", // 320px
                md: "w-[28rem]", // 448px
                lg: "w-[32rem]", // 512px
                xl: "w-[36rem]", // 576px
                "2xl": "w-[42rem]", // 672px
                "3xl": "w-[48rem]", // 768px
                "4xl": "w-[56rem]", // 896px
                "5xl": "w-[64rem]", // 1024px
                "6xl": "w-[72rem]", // 1152px
                "7xl": "w-[80rem]", // 1280px
            },
        },
        defaultVariants: {
            variant: "classic",
            size: "md",
        },
    },
);

const ClassicDialog: FC<ClassicDialogProps> = ({
    size,
    width,
    variant,
    title,
    header,
    icon: Icon,
    children,
    className,
    contentClassName,
    loading,
    rootRef,
    ...rest
}) => (
    <Dialog {...rest}>
        <div
            ref={rootRef}
            style={{ width }}
            className={classicDialogVariants({ variant, size, className })}
        >
            <div
                className={cn(
                    "w-xl flex items-center justify-center gap-x-2 rounded-t-3xl bg-gradient-decor-to-r fill-current p-6 text-white",
                    loading && "relative",
                )}
            >
                {Icon && <Icon width="20" height="20" />}
                {header ? header : <h2 className="text-lg">{title}</h2>}
                {loading?.value && (
                    <Loader
                        width="20"
                        height="20"
                        className="absolute right-4 text-white"
                    />
                )}
            </div>
            <div className={cn("rounded-b-3xl bg-white p-6", contentClassName)}>
                {children}
            </div>
        </div>
    </Dialog>
);

export default ClassicDialog;
